import React from "react";
import { Link } from "react-router-dom";
import ExamMarksAnalytics from "../../components/analytics/ExamMarksAnalytics";

/**
 * Dedicated Exams & Marks analytics page.
 * Mounted at two routes in App.js:
 *   owner: /analytics/exams              -> <ExamMarksAnalyticsPage isPortal={false} />
 *   staff: /staff-panel/analytics/exams  -> <ExamMarksAnalyticsPage isPortal={true} />
 *
 * Staff route is gated with ModuleGuard EXAM_MANAGEMENT + PermissionGuard EXAM_MANAGEMENT_VIEW.
 */
const ExamMarksAnalyticsPage = ({ isPortal = false }) => {
  const homeUrl = isPortal ? "/staff-home" : "/school-home";
  const hubUrl = isPortal ? "/staff-panel/analytics" : "/analytics";

  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-800 dark:bg-neutral-900">
      <div className="max-w-6xl mx-auto p-6">
        <nav className="mb-4 flex flex-wrap items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
          <Link to={homeUrl} className="hover:text-violet-600">
            Home
          </Link>
          <span>/</span>
          <Link to={hubUrl} className="hover:text-violet-600">
            Analytics
          </Link>
          <span>/</span>
          <span className="font-medium text-neutral-800 dark:text-neutral-100">Exams & Marks Analytics</span>
        </nav>

        <h1 className="text-2xl font-bold text-neutral-800 dark:text-neutral-100 mb-6">Exams & Marks Analytics</h1>

        <ExamMarksAnalytics isPortal={isPortal} />
      </div>
    </div>
  );
};

export default ExamMarksAnalyticsPage;
